import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6ddd672"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex column fill" }
const _hoisted_2 = ["onMouseover"]
const _hoisted_3 = { class: "side relative" }
const _hoisted_4 = {
  key: 0,
  class: "flex align-start block-side-buttons"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "block-actions" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "module-actions" }
const _hoisted_12 = { class: "add-blocks-tray" }
const _hoisted_13 = { class: "flex-grow plr-1 block-component" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "side" }, null, -1))

import { computed, ref } from "vue";
import Edit from "./Edit";
import Tray from "@/components/Tray.vue";
import Module from "./Module";
import Block from "./Block";


export default /*#__PURE__*/_defineComponent({
  __name: 'Editor',
  props: {
    getEdit: null,
    modules: null,
    defaultBlock: null
  },
  setup(__props: any) {

const props = __props as {
	getEdit: () => Edit;
	modules: { [key: string]: Module };
	defaultBlock: Block;
}



const edit = computed({
	get: () => props.getEdit(),
	set: (value: Edit) => {
		Object.assign(props.getEdit(), value);
	}
});

const lastHover = ref(0);
const openActions = ref<null | number>(null);
const openAdd = ref<null | number>(null);

const getReactiveBlock = (index: number) => {
	return edit.value.blocks[index];
};

function openActionsClicked(index: number) {
	// If the openAdd is open, close it
	openAdd.value = null;

	// Check if the actions tray is already open
	if (openActions.value == index) {
		openActions.value = null;
		return;
	}

	openActions.value = index;
}

function openAddClicked(index: number) {
	// If the openActions is open, close it
	openActions.value = null;

	// Check if the actions tray is already open
	if (openAdd.value == index) {
		openAdd.value = null;
		return;
	}

	openAdd.value = index;
}

function up(index: number) {
	// Close the openActions
	openActions.value = null;

	const block = edit.value.blocks[index];
	if (index == 0) return;
	edit.value.blocks[index] = edit.value.blocks[index - 1];
	edit.value.blocks[index - 1] = block;
}

function down(index: number) {
	// Close the openActions
	openActions.value = null;

	const block = edit.value.blocks[index];
	if (index == edit.value.blocks.length - 1) return;
	edit.value.blocks[index] = edit.value.blocks[index + 1];
	edit.value.blocks[index + 1] = block;
}

function add(index: number) {
	// Close the openAdd
	openAdd.value = null;

	edit.value.blocks.splice(
		index + 1,
		0,
		// This is expensive, we should use something cheaper
		JSON.parse(JSON.stringify(props.defaultBlock))
	);
}

function remove(index: number) {
	// Close the openActions
	openActions.value = null;

	edit.value.blocks.splice(index, 1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(edit).blocks, (block, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "flex align-center",
        key: block.id,
        onMouseover: ($event: any) => (lastHover.value = index)
      }, [
        _createElementVNode("div", _hoisted_3, [
          (
						(lastHover.value == index && openActions.value == null && openAdd.value == null) ||
						openActions.value == index ||
						openAdd.value == index
					)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("i", {
                  class: "fa-fw fa-solid fa-plus",
                  onClick: _withModifiers(($event: any) => (openAddClicked(index)), ["stop"])
                }, null, 8, _hoisted_5),
                _createElementVNode("i", {
                  class: "fa-fw fa-solid fa-ellipsis-vertical",
                  onClick: _withModifiers(($event: any) => (openActionsClicked(index)), ["stop"])
                }, null, 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true),
          (openActions.value == index)
            ? (_openBlock(), _createBlock(Tray, {
                key: 1,
                prefer: "bottom",
                onClickedAway: _cache[1] || (_cache[1] = ($event: any) => (openActions.value = null))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("i", {
                      class: "fa-solid fa-arrow-up",
                      onClick: ($event: any) => (up(index))
                    }, null, 8, _hoisted_8),
                    _createElementVNode("i", {
                      class: "fa-solid fa-trash",
                      onClick: ($event: any) => (remove(index))
                    }, null, 8, _hoisted_9),
                    _createElementVNode("i", {
                      class: "fa-solid fa-arrow-down",
                      onClick: ($event: any) => (down(index))
                    }, null, 8, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(__props.modules[block.type].blockConfigComponent), {
                      getBlock: () => getReactiveBlock(index),
                      onClose: _cache[0] || (_cache[0] = ($event: any) => (openActions.value = null))
                    }, null, 40, ["getBlock"]))
                  ])
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (openAdd.value == index)
            ? (_openBlock(), _createBlock(Tray, {
                key: 2,
                prefer: "bottom",
                onClickedAway: _cache[2] || (_cache[2] = ($event: any) => (openAdd.value = null))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(__props.modules[block.type].addBlockComponent), {
                      onClick: ($event: any) => (add(index))
                    }, null, 8, ["onClick"]))
                  ])
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(__props.modules[block.type].blockComponent), {
            getBlock: () => getReactiveBlock(index)
          }, null, 8, ["getBlock"]))
        ]),
        _hoisted_14
      ], 40, _hoisted_2))
    }), 128))
  ]))
}
}

})